import { render, staticRenderFns } from "./ConfirmarPedido.vue?vue&type=template&id=440a3d48&"
import script from "./ConfirmarPedido.vue?vue&type=script&lang=js&"
export * from "./ConfirmarPedido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports